
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import u from '@/utility/utility';
import ListOrder from './components/ListOrder.vue';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import formatNumber from '@/shared/filters/format-number';
import { Customer } from '@/models/customer';
import authService from '@/services/auth-services';
import orderService from '@/services/transition-services';

@Component({
    components: {
        Loading,
        'list-order': ListOrder
    }
})
export default class AddNewPaymentRequest extends Vue {
    private listOrders: BillOfLadingModel[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listOrders.filter(x => x.isChecked === true).length;
    }

    get paymentRequestOrders() {
        return this.$store.state[APP_CONFIG.stateKey.cartState].paymentRequestOrders;
    }

    private async created() {
        await this.getListOrder();
    }

    private getStatus(value: any) {
        return DATA.billOfLadingStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async getListOrder() {
        const paramsFilter: any = {
            filters: [],
            quickFilters: []
        };
        
        paramsFilter.filters.push({
                column: 'Status',
                value: 3,
                condition: 'equal'
            });
        paramsFilter.filters.push({
                column: 'RequestID',
                value: 0,
                condition: 'equal'
            });
        this.isLoading = true;
        const result = await orderService.getList(1, 10000, paramsFilter.filters, paramsFilter.quickFilters);
        if (result && result.data && result.data.status === 200) {
            const tmpListOrder: BillOfLadingModel[] = [];
            for (const item of result.data.data) {
                const order = new BillOfLadingModel();
                order.id = item.ID;
                order.createdDate = item.CreatedDate;
                order.status = item.Status;
                order.statusDetail = this.getStatus(item.Status);
                order.orderTransactionCode = item.OrderTransactionCode;
                order.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                order.volume = item.Volume > 0 ? `${formatNumber(item.Volume, '0,0.[0000]')} m3` : '';
                order.isChecked = false;
                tmpListOrder.push(order);
            }
            this.listOrders = tmpListOrder;
        } else {
            this.listOrders = [];
        }
        this.isLoading = false;
    }

    private async submitPaymentRequest() {
        (window['getApp'] as any).$emit('SET_SELECTED_ORDER', this.listOrders.filter(x => x.isChecked === true));
        this.$router.push({ name: 'payment-request-new-step2' });
    }

    private async onCheckAll(isCheckAll: boolean) {
        this.listOrders = this.listOrders.map(x => {
            return {
                ...x,
                isChecked: isCheckAll
            }
        });
    }
}
